var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoinbase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_28179_6566)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 0.5C15.2473 0.5 19.5 4.75273 19.5 10C19.5 15.2473 15.2473 19.5 10 19.5C4.75273 19.5 0.5 15.2473 0.5 10C0.5 4.75273 4.75273 0.5 10 0.5Z",
    fill: "#0052FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0019 13.3398C8.15752 13.3398 6.66201 11.8462 6.66201 10C6.66201 8.15381 8.15752 6.66016 10.0019 6.66016C11.6551 6.66016 13.0281 7.86621 13.2916 9.44336H16.6556C16.3717 6.01445 13.5013 3.32031 10 3.32031C6.31133 3.32031 3.32031 6.31133 3.32031 10C3.32031 13.6887 6.31133 16.6797 10 16.6797C13.5013 16.6797 16.3717 13.9855 16.6556 10.5566H13.2897C13.0244 12.1338 11.6551 13.3398 10.0019 13.3398Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_28179_6566"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 19,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoinbase);
export default __webpack_public_path__ + "static/media/coinbase.2446451f08ff13fbfabc7bb54500e1ee.svg";
export { ForwardRef as ReactComponent };